import { useSelector, useDispatch } from 'react-redux';
import { SearchLayout } from '@layout/SearchLayout';
import { Component as ComponentContainer } from '@styles/layout';
import { BaseComponent } from '@model/content';
import { Filter } from '@model/iceberg';
import { FiltersAdapter } from '@model/iceberg/filters/deal-finder/filters-adapter';
import {
  getFromPricePackageFiltered,
  getFromPricePackagesHasResults,
  setFromPriceFilters
} from '@state/search-results';
import { FromPriceResultsContainer } from '@components/search-results/from-price-results';
import { FromPricePackagesNoResults } from '@components/search-results/no-results/from-price-packages-no-results/FromPricePackagesNoResultsContainer';
import { FiltersSideBarContainer } from '@components/filters/v2/from-prices/FiltersSideBarContainer';
import { FiltersMobileDrawerContainer } from '@components/filters/v2/from-prices/FiltersMobileDrawerContainer';

export const DealfinderResultsContainer = ({ destination, path, data }: BaseComponent) => {
  const dispatch = useDispatch();
  const count: number = useSelector(getFromPricePackageFiltered) || 0;
  const canShowResults: boolean = useSelector(getFromPricePackagesHasResults);
  const { offerType } = data;

  const handleOnFiltersChange = (payload: Array<Filter>) => {
    const query: Record<string, string> = FiltersAdapter.getQuery(payload);
    const withOffers: Record<string, string> = { ...query, offerType, path };
    dispatch(setFromPriceFilters(withOffers));
  };
  const handleOnResetFilters = () => {
    dispatch(setFromPriceFilters({ offerType, path }));
  };

  return (
    <ComponentContainer isEdgeToEdge>
      <SearchLayout
        searchComponent={<FromPriceResultsContainer onResetFilters={handleOnResetFilters} offerType={offerType} />}
        noResults={<FromPricePackagesNoResults display={destination?.display || ''} path={path} />}
        canShowSearch={canShowResults}
        renderFilters={() => (
          <FiltersSideBarContainer
            title
            onFiltersChange={handleOnFiltersChange}
            onFiltersReset={handleOnResetFilters}
          />
        )}
        renderMobileFilters={(props: any) => (
          <FiltersMobileDrawerContainer
            {...props}
            count={count}
            onResetFilters={handleOnResetFilters}
            onFiltersChange={handleOnFiltersChange}
          />
        )}
      />
    </ComponentContainer>
  );
};
